import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import type { TalkGroupRecord } from '#shared/cms/records'

type TalkGroupValue = Omit<TalkGroupRecord, '$type'>

interface TalkGroupEntry {
  rkey: string
  uri: string
  cid: string
  value: TalkGroupRecord
}

// `watch: false` stops useFetch firing one last `/.../undefined` request
// when `navigateTo` clears `route.params.rkey` on unmount.

export default /*@__PURE__*/_defineComponent({
  __name: '[rkey]',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'Edit talk group - admin - Daniel Roe' })

const route = useRoute()
const rkey = computed(() => {
  const raw = route.params.rkey
  return typeof raw === 'string' && raw ? raw : null
})

if (!rkey.value) {
  throw createError({ statusCode: 404, statusMessage: 'Missing rkey.' })
}

const { data, loading } = useAdminFetch<TalkGroupEntry>(`/api/admin/talk-groups/${rkey.value}`, {
  watch: false,
})

async function save (value: TalkGroupValue) {
  if (!rkey.value) return
  await $fetch(`/api/admin/talk-groups/${rkey.value}`, { method: 'PUT', body: value })
  await navigateTo('/admin/talks')
}

return (_ctx: any,_cache: any) => {
  const _component_AdminTalkGroupForm = _resolveComponent("AdminTalkGroupForm")!
  const _component_AdminSkeletonForm = _resolveComponent("AdminSkeletonForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "Edit talk group" }, {
    default: _withCtx(() => [
      (_unref(data))
        ? (_openBlock(), _createBlock(_component_AdminTalkGroupForm, {
            key: 0,
            initial: _unref(data).value,
            "submit-label": "Save",
            onSubmit: save
          }, null, 8, ["initial"]))
        : (_unref(loading))
          ? (_openBlock(), _createBlock(_component_AdminSkeletonForm, {
              key: 1,
              fields: ['text', 'textarea']
            }))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})